import {isDetailsMode, useFormMode} from "@contexts/FormModeContext";

export default function RequiredSign({required= true}) {
   
   const {mode} = useFormMode();
   
   if(isDetailsMode(mode)) {
      return null;
   }
   
    return (
        !!required ? <em className="required"/> : ''
    );
}